<template>
  <svg :x="x" :y="y" width="200" height="200" viewBox="0 0 164 150" fill="none" class="svg-streetlamp">
    <defs>
      <linearGradient
        id="lightlinear"
        x1="46.353"
        y1="-119.5"
        x2="46.353"
        y2="60.984"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#f9df81" />
        <stop offset="1" stop-color="#f9df81" stop-opacity="0.1" />
      </linearGradient>
    </defs>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.979 8.606l30.435 57.713S39.088 113.421.329 52.861L44.03 10.418 61.98 8.606z"
      fill="url(#lightlinear)"
    />
    <path
      stroke="#000"
      d="M79.241 143.273l4.991 4.992M81.966 143.273l4.992 4.992M84.692 143.273l4.991 4.992M87.417 143.273l4.992 4.992M90.143 143.273l4.992 4.992M92.869 143.273l4.991 4.992M95.594 143.273l4.992 4.992M98.32 143.273l4.991 4.992M101.045 143.273l4.992 4.992M103.771 143.273l4.992 4.992M106.496 143.273l4.992 4.992M109.222 143.273l4.992 4.992M111.948 143.273l4.991 4.992M114.673 143.273l4.992 4.992M117.399 143.273l4.992 4.992M120.124 143.273l4.992 4.992M122.85 143.273l4.992 4.992M125.576 143.273l4.991 4.992M128.301 143.273l4.992 4.992M131.027 143.273l4.991 4.992M133.752 143.273l4.992 4.992M136.478 143.273l4.992 4.992M139.204 143.273l4.991 4.992M141.929 143.273l4.992 4.992M144.655 143.273l4.991 4.992M147.38 143.273l4.992 4.992M150.106 143.273l4.992 4.992M152.831 143.273l4.992 4.992M155.557 143.273l4.992 4.992M158.283 143.273l4.991 4.992"
    />
    <path
      d="M76.806 22.154a.5.5 0 00-.76.427v123.191a.5.5 0 00.24.427l4.683 2.847a.499.499 0 00.76-.427V25.429a.5.5 0 00-.241-.428l-4.682-2.847z"
      fill="#C6B4B7"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M53.919 12.4a.5.5 0 00.497.009l7.544-4.141a.5.5 0 00.01-.87L51.306 1.185a.5.5 0 00-.498-.002l-7.284 4.14a.5.5 0 00-.009.864L53.919 12.4z"
      fill="#F1EEE8"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M44.027 5.33a.5.5 0 00-.757.43v4.399a.5.5 0 00.244.43l10.405 6.21a.5.5 0 00.756-.429v-4.4a.5.5 0 00-.243-.429L44.027 5.33z"
      fill="#C6B4B7"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M62.219 7.83a.5.5 0 00-.74-.44l-7.544 4.142a.5.5 0 00-.26.438v4.4a.5.5 0 00.752.431l7.544-4.4a.5.5 0 00.248-.431V7.83z"
      fill="#A29296"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M76.304 22.144a.5.5 0 00-.018.864l4.683 2.847a.5.5 0 00.519 0l4.682-2.847a.5.5 0 00-.018-.864l-4.682-2.588a.5.5 0 00-.484 0l-4.682 2.588z"
      fill="#F1EEE8"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M79.411 20.599a.5.5 0 00.004.86l4.422 2.589a.5.5 0 00.509-.002l1.3-.777a.5.5 0 00-.003-.86L81.22 19.82a.5.5 0 00-.51.003l-1.3.776z"
      fill="#B3A2A6"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M86.41 22.581a.5.5 0 00-.776-.416l-2.324 1.541-2.324 1.285a.5.5 0 00-.258.437V148.62a.5.5 0 00.742.437l2.341-1.294a.27.27 0 00.035-.021l2.34-1.553a.499.499 0 00.224-.416V22.581z"
      fill="#A29296"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M81.759 25.343a.5.5 0 00.75-.433V23.1a.5.5 0 00-.253-.435L51.3 5.065a.5.5 0 00-.747.435v1.553a.5.5 0 00.25.433l30.955 17.857z"
      fill="#2D090A"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M81.761 23.533a.5.5 0 00.512-.01l2.08-1.294a.5.5 0 00-.016-.859L53.382 3.771a.5.5 0 00-.511.01L50.79 5.075a.5.5 0 00.017.86L81.76 23.533z"
      fill="#402F30"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
    <path
      d="M81.509 24.91a.5.5 0 00.799.401l1.004-.75 1-.497a.5.5 0 00.278-.448v-1.811a.5.5 0 00-.8-.401l-1.004.75-1 .497a.5.5 0 00-.277.448v1.811z"
      fill="#2D090A"
      stroke="#0E1E25"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    x: {
      type: [Number, String],
      default: 500,
    },
    y: {
      type: [Number, String],
      default: 500,
    },
  },
}
</script>

<style lang="scss" scoped></style>
